import FactureForfaitaire from '@/components/comptable/creance/creance-forfaitaire/facture-forfaitaire'
import SocieteForfaitaire from '@/components/comptable/creance/creance-forfaitaire/societes-forfaitaires'

export default {
    name: 'creance-forfaitaire',
    components: {
        FactureForfaitaire, SocieteForfaitaire
    },
    props: [],
    data() {
        return {
            is_facture: true,
            user_info: {}
        }
    },
    
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.user_info = {
            name: this.userCredentials.user.name,
            user_id: this.userCredentials.user.id,
            titre: this.userCredentials.user.titre
        }
    },

    methods: {
        toggleView() {
            this.is_facture = !this.is_facture
        },

        printFactureFirfait(invoice_data) {
            console.log(">> to print 2",invoice_data);
            this.$emit('emitPrintFactureSociete', invoice_data)
        }
    }
}